// @ts-expect-error not migrated to TS yet

import { PROPERTIES } from 'email-management-lib/Shared/constants/frameworkTable';
import { VISIBLE_TO } from 'email-management-lib/Shared/constants/manage';
import EmailTitleCell from 'email-management-lib/refactor/components/manage/frameworkTable/cells/EmailTitleCell';
import IssueDescriptionCell from 'email-management-lib/refactor/components/manage/frameworkTable/cells/IssueDescriptionCell';
import PreviewLinkCell from 'email-management-lib/refactor/components/manage/frameworkTable/cells/PreviewLinkCell';
import StatsCell from 'email-management-lib/refactor/components/manage/frameworkTable/cells/StatsCell';
import StatsRateCell from 'email-management-lib/refactor/components/manage/frameworkTable/cells/StatsRateCell';
import SubscriptionCell from 'email-management-lib/refactor/components/manage/frameworkTable/cells/SubscriptionCell';
import UserCell from 'email-management-lib/refactor/components/manage/frameworkTable/cells/UserCell';
import VisibleToCell from 'email-management-lib/refactor/components/manage/frameworkTable/cells/VisibleToCell';
import { useCallback } from 'react';
import { UserObjectTimezoneTooltip } from 'ui-asset-management-lib';
import { UserObjectTzCell, UserObjectTzHeader } from '../cells/UserObjectTzCell';
import { jsx as _jsx } from "react/jsx-runtime";
export default function useRenderCustomColumn(manageProps) {
  return useCallback(({
    columnId
  }) => {
    switch (columnId) {
      default:
        return null;
      case PROPERTIES.NAME:
        return {
          renderCell: props => /*#__PURE__*/_jsx(EmailTitleCell, Object.assign({}, manageProps, props)),
          hoverCell: true,
          sortable: true,
          width: 500
        };
      case PROPERTIES.UPDATED_BY:
        return {
          renderCell: props => /*#__PURE__*/_jsx(UserCell, Object.assign({}, props)),
          sortable: false,
          width: 300
        };
      case PROPERTIES.HS_CREATED_BY_USER_ID:
        return {
          renderCell: props => /*#__PURE__*/_jsx(UserCell, Object.assign({}, props)),
          sortable: false,
          width: 300
        };
      case PROPERTIES.PUBLISH_AUTHOR:
        return {
          renderCell: props => /*#__PURE__*/_jsx(UserCell, Object.assign({}, props)),
          sortable: false,
          width: 300
        };
      case PROPERTIES.DELETED_BY_ID:
        return {
          renderCell: props => /*#__PURE__*/_jsx(UserCell, Object.assign({}, props)),
          sortable: false,
          width: 300
        };
      case VISIBLE_TO:
        return {
          renderCell: props => /*#__PURE__*/_jsx(VisibleToCell, Object.assign({}, props)),
          sortable: false,
          width: 300
        };
      case PROPERTIES.SUBSCRIPTION:
        return {
          renderCell: props => /*#__PURE__*/_jsx(SubscriptionCell, Object.assign({}, props)),
          sortable: false,
          width: 300
        };
      case PROPERTIES.PREVIEW_KEY:
        return {
          renderCell: props => /*#__PURE__*/_jsx(PreviewLinkCell, Object.assign({}, props)),
          sortable: false,
          width: 300
        };
      case PROPERTIES.ERROR_TAGS:
        return {
          renderCell: props => /*#__PURE__*/_jsx(IssueDescriptionCell, Object.assign({}, props)),
          sortable: false,
          width: 600
        };
      // Number cells
      case PROPERTIES.BOUNCES:
      case PROPERTIES.CLICKS:
      case PROPERTIES.DELIVERED:
      case PROPERTIES.HARD_BOUNCES:
      case PROPERTIES.OPENS:
      case PROPERTIES.REPLIES:
      case PROPERTIES.SENT:
      case PROPERTIES.NOT_SENT:
      case PROPERTIES.SOFT_BOUNCES:
      case PROPERTIES.SPAM_REPORTS:
      case PROPERTIES.UNSUBSCRIBED:
        return {
          renderCell: props => /*#__PURE__*/_jsx(StatsCell, Object.assign({}, props)),
          sortable: true,
          width: 200
        };
      case PROPERTIES.BOUNCE_RATE:
      case PROPERTIES.CLICK_RATE:
      case PROPERTIES.CLICK_THROUGH_RATE:
      case PROPERTIES.DELIVERY_RATE:
      case PROPERTIES.HARD_BOUNCES_RATE:
      case PROPERTIES.OPEN_RATE:
      case PROPERTIES.REPLY_RATE:
      case PROPERTIES.SOFT_BOUNCES_RATE:
      case PROPERTIES.SPAM_REPORTS_RATE:
      case PROPERTIES.UNSUBSCRIBE_RATE:
        return {
          renderCell: props => /*#__PURE__*/_jsx(StatsRateCell, Object.assign({}, props)),
          sortable: true,
          width: 200
        };
      case PROPERTIES.CREATED_AT:
      case PROPERTIES.LAST_UPDATED:
      case PROPERTIES.LAST_MODIFIED_DATE:
      case PROPERTIES.ERROR_DATE:
      case PROPERTIES.PUBLISHED_AT:
      case PROPERTIES.PUBLISHED_DATE:
      case PROPERTIES.HS_CREATED_DATE:
      case PROPERTIES.DELETED_DATE:
        if (manageProps.isUngatedForTimezoneUtil) {
          return {
            renderHeader: props => /*#__PURE__*/_jsx(UserObjectTzHeader, Object.assign({}, props)),
            renderCell: props => /*#__PURE__*/_jsx(UserObjectTzCell, Object.assign({}, props)),
            HeaderTooltip: /*#__PURE__*/_jsx(UserObjectTimezoneTooltip, {
              stopPropagation: true
            })
          };
        }
        return null;
    }
  }, [manageProps]);
}